$(function () {
    $('.mvc-form-select-wrapper select').each(function () {
        var $select = $(this);

        function updatePlaceholderState() {
            var value = $select.val();

            if (value === '' || value === null) {
                $select.addClass('is-select-placeholder');
            } else {
                $select.removeClass('is-select-placeholder');
            }
        }

        updatePlaceholderState();
        $select.on('change', updatePlaceholderState);
    });
});
